// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".9fbe4e9ef52eb44b81a4366655c1b427aa6a985d.chunk.js";
};